<template>
  <div v-if="!loading" class="h-100">
    <top-bar
      :fields="fields"
      :per-page="perPage"
      :total="totalRows"
      :filters="filters"
      :havePermissionToCreate="havePermissionToCreate"
      :havePermissionToRemove="havePermissionToRemove"
      create-route="groupsCreate"
      @updateFilters="updateFilters"
      @updatePerPage="updatePerPage"
      @updateVisibleFields="updateVisibleFields"
      @removeSelectedItems="removeSelectedItems"
    />
    <template v-if="items.length">
      <b-table
        ref="table"
        :items="items"
        :fields="visibleFields"
        :per-page="perPage"
        :current-page="1"
        borderless
        striped
        responsive
        @head-clicked="updateSortListBy"
      >
        <template slot="HEAD_checkbox">
          <b-checkbox v-model="selectAll" @change="toggleAllSelectedItems" />
        </template>
        <template slot="HEAD_actions">
          <list-display-columns
            :fields="fields"
            @updateVisibleFields="updateVisibleFields"
          />
        </template>
        <template slot="checkbox" slot-scope="data">
          <b-checkbox v-model="data.item.selected" />
        </template>
        <template v-for="(field, i) in fields" :slot="`HEAD_${field.field}`">
          <list-table-header
            :key="i"
            :field="field"
            :sort-direction="sortDirection"
            :sort-by="sortBy"
          />
        </template>
        <template v-for="field in fields" :slot="field.field" slot-scope="data">
          <span :key="field.field">
            {{ data.item[field.field] }}
          </span>
        </template>
        <template slot="actions" slot-scope="data">
          <table-actions
            :havePermissionToEdit="havePermissionToEdit"
            :havePermissionToRemove="havePermissionToRemove"
            update-route="groupsUpdate"
            :data="data"
            @removeItem="removeItem"
          />
        </template>
      </b-table>

      <pagination
        :current-page="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @change="getList"
      />
    </template>
    <template
      v-else
      class="w-100 h-100 d-flex align-items-center justify-content-center font-weight-bold"
    >
      <p>
        {{ $t("list.no_data", { data: this.$t("menu.groups").toLowerCase() }) }}
      </p>
    </template>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import api from '@/api/groups'
import model from '@/models/groups'
import actions from '@/mixins/list'
import permissions from '@/mixins/permissions'
import pagination from '@/components/common/pagination'
import listDisplayColumns from '@/components/common/listDisplayColumns'
import listTableHeader from '@/components/common/listTableHeader'

export default {
  components: {
    pagination,
    listDisplayColumns,
    listTableHeader
  },
  mixins: [actions, permissions],
  data: () => ({
    items: null,
    loading: true,
    api: api,
    fields: model.fields,
    filters: JSON.parse(JSON.stringify(model.filters)),
    visibleFields: [],
    sortBy: 'id',
    sortDirection: 'desc'
  }),
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.updateVisibleFields(), this.getList()])

      this.loading = false
    }
  }
}
</script>
